import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { helpers } from "../../../services";
import useTranslation from "../../../hooks/useTranslation";
import "./style.scss";
import { Tag } from "antd";

const Detail = ({ selected }) => {
	const { tr } = useTranslation();
	const [orders, setOrders] = useState([]);

	useEffect(() => {
		setOrders([selected]);
	}, []);

	return (
		<div>
			<div className="modal-title">
				{tr("Заказ")} - {get(selected, "order_number")}{" "}
				{selected.restored_at ? (
					<p className="my-0 text-base font-normal">
						<Tag color="volcano">
							{tr("Восстановленный чек")}:{" "}
							{new Date(selected.restored_at).toLocaleDateString("ru-RU", {
								year: "numeric",
								month: "short",
								day: "numeric",
								hour: "numeric",
								minute: "2-digit"
							})}
						</Tag>
					</p>
				) : null}
			</div>

			<div className="modal-body">
				<table className="default-table --small">
					<thead>
						<tr>
							<th className="w-50">№</th>
							<th>{tr("Наименование")}</th>
							<th className="w-50 text-cen">{tr("Кол-во")}</th>
							<th className="w-100 text-right ws-no-wrap">{tr("Цена")}</th>
							<th className="w-100 text-right ws-no-wrap">{tr("Цена со скидкой")}</th>
							<th className="w-100 text-right ws-no-wrap">{tr("Сумма")}</th>
						</tr>
					</thead>
					<tbody>
						{orders.map(order => {
							return (
								get(order, "items", []).length > 0 && (
									<React.Fragment key={get(order, "id", get(order, "order_number"))}>
										{get(order, "items", []).map((good, ind) => {
											const itemPrice = Number(get(good, "price", 0)) || 0;
											const itemDiscount = Number(get(good, "discount_amount", 0)) || 0;
											const sumWithDiscount = itemPrice - itemDiscount;
											return (
												<React.Fragment key={get(good, "id", `${get(order, "id", "order")}_${ind}`)}>
													<tr className="parent-row">
														<td>{ind + 1}</td>
														<td>{get(good, "product_name")}</td>
														<td className="w-50 text-cen">
															{helpers.checkNumber(get(good, "quantity", 0))}
														</td>
														<td className="w-100 text-right ws-no-wrap">
															{helpers.formatNumber(
																itemPrice
															)}
														</td>
														<td className="w-100 text-right ws-no-wrap">
															{helpers.formatNumber(sumWithDiscount)}
														</td>
														<td className="w-100 text-right ws-no-wrap">
															{helpers.formatNumber(
																Number(get(good, "total_price", 0))
															)}
														</td>
													</tr>

													{/* {Array.isArray(get(good, "children", [])) &&
														get(good, "children", []).length > 0 &&
														get(good, "children", []).map(function (ch, cind) {
															return (
																<tr
																	className="subrow"
																	key={
																		"child_" + order.id + "_" + (ch.id || cind)
																	}
																>
																	<td className="fo-6"> </td>
																	<td className="fo-6">
																		— {get(ch, "dish.name", "")}
																	</td>
																	<td className="w-50 text-cen fo-6"></td>
																	<td className="w-100 text-right ws-no-wrap fo-6"></td>
																	<td className="w-100 text-right ws-no-wrap fo-6"></td>
																</tr>
															);
														})} */}
												</React.Fragment>
											);
										})}
										<tr>
											<td></td>
											<td colSpan={4}>{tr("Товары")}</td>
											<td className="text-right ws-no-wrap">
												{helpers.formatNumber(get(order, "price", 0))}
											</td>
										</tr>
										<tr>
											<td></td>
											<td colSpan={4}>{tr("Скидка")}</td>
											<td className="text-right ws-no-wrap">
												{helpers.formatNumber(get(order, "discount_amount", 0))}
											</td>
										</tr>
										{/* <tr>
											<td></td>
											<td colSpan={3}>{tr("Место")}</td>
											<td className="text-right ws-no-wrap">
												{helpers.convertToReadable(get(order, "place_price", 0))}
											</td>
										</tr> */}
										<tr>
											<td></td>
											<td colSpan={4}>{tr("Общее")}</td>
											<td className="text-right fw-700 ws-no-wrap">
												{helpers.formatNumber(get(order, "total_price", 0))}
											</td>
										</tr>
									</React.Fragment>
								)
							);
						})}
						{orders.length > 1 && (
							<tr>
								<td></td>
								<td colSpan={4} className="fw-700">
									{tr("Общее")}
								</td>
								<td className="text-right fw-700 ws-no-wrap">
									{helpers.formatNumber(selected.price)}
								</td>
							</tr>
						)}
					</tbody>
					<tbody>
						{orders &&
							orders.map(order => {
								return (
									get(order, "removed_goods", []).length > 0 && (
										<tr>
											<td colSpan={6}>
												<div className="cancelled-order-group">
													<div className="cancelled-order-title">
														{tr("Отмененные заказы")}
														{/* {tr("Отмененные заказы")} {order.id} */}
													</div>

													<table className="" style={{ width: "100%" }}>
														<tbody>
															{get(order, "removed_goods", []).map((good, ind) => (
																<tr key={ind}>
																	<td style={{ background: "#fff0f0" }}>
																		{ind + 1}
																	</td>
																	<td style={{ background: "#fff0f0" }}>
																		{good.dish.name}
																	</td>
																	<td
																		className="w-50 text-cen"
																		style={{ background: "#fff0f0" }}
																	>
																		{good.quantity}
																	</td>
																	<td
																		className="w-100 text-right ws-no-wrap"
																		style={{ background: "#fff0f0" }}
																	>
																		{helpers.formatNumber(good.price)}
																	</td>
																	<td
																		className="w-100 text-right ws-no-wrap"
																		style={{ background: "#fff0f0" }}
																	>
																		{helpers.formatNumber(
																			Number(good.price) * good.quantity
																		)}
																	</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											</td>
										</tr>
									)
								);
							})}
					</tbody>
					<tbody>
						{orders &&
							orders.map(order => {
								return (
									get(order, "returned_goods", []).length > 0 && (
										<tr>
											<td colSpan={6}>
												<div className="cancelled-order-group">
													<div className="cancelled-order-title">
														{tr("Возвращенные товары")}
													</div>

													<table className="" style={{ width: "100%" }}>
														<tbody>
															{get(order, "returned_goods", []).map((good, ind) => (
																<tr key={ind}>
																	<td style={{ background: "#fff0f0" }}>
																		{ind + 1}
																	</td>
																	<td style={{ background: "#fff0f0" }}>
																		{good.dish.name}
																	</td>
																	<td
																		className="w-50 text-cen"
																		style={{ background: "#fff0f0" }}
																	>
																		{good.quantity}
																	</td>
																	<td
																		className="w-100 text-right ws-no-wrap"
																		style={{ background: "#fff0f0" }}
																	>
																		{helpers.formatNumber(good.price)}
																	</td>
																	<td
																		className="w-100 text-right ws-no-wrap"
																		style={{ background: "#fff0f0" }}
																	>
																		{helpers.formatNumber(
																			Number(good.price) * good.quantity
																		)}
																	</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											</td>
										</tr>
									)
								);
							})}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default Detail;
